import client from "./client";

const supportRequest = async (method, path, payload) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 25000);
  try {
    return await (method === "get" ? client.get(path, { signal: controller.signal }) : client.post(path, payload, { signal: controller.signal }));
  } catch (error) {
    if (controller.signal.aborted) throw Object.assign(new Error("The connection timed out. Your draft is saved; retry to confirm the result."), { status: 0 });
    throw error;
  } finally { clearTimeout(timeout); }
};

const sanitizeParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !(typeof value === "string" && value.trim() === "")
    )
  );

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams(sanitizeParams(params)).toString();
  return query ? `?${query}` : "";
};

export const fetchSupportTickets = (params = {}) =>
  supportRequest("get", `/portal/support-tickets${buildQueryString(params)}`);

export const fetchSupportTicketMetadata = (params = {}) =>
  supportRequest("get", `/portal/support-tickets/meta${buildQueryString(params)}`);

export const fetchSupportTicket = (ticketId) => {
  if (!ticketId) {
    return Promise.reject(new Error("Ticket ID is required"));
  }
  return supportRequest("get", `/portal/support-tickets/${encodeURIComponent(ticketId)}`);
};

export const createSupportTicket = (payload) =>
  supportRequest("post", "/portal/support-tickets", payload);

export const continueSupportTicket = (ticketId, payload = {}) =>
  supportRequest("post", `/portal/support-tickets/${encodeURIComponent(ticketId)}/continue`, payload);

export const recordSupportDeskEvent = (payload) =>
  client.post("/portal/support-tickets/events", payload);

export const recordSupportFaqEvent = (payload) =>
  client.post("/portal/support-tickets/faq-events", payload);

export const requestSupportAttachmentUpload = (payload) =>
  client.post("/portal/support-tickets/attachments/presign", payload);

export const notifySupportAttachmentUploadComplete = (payload) =>
  client.post("/portal/support-tickets/attachments/track", payload);

export const addSupportTicketMessage = (ticketId, payload) => {
  if (!ticketId) {
    return Promise.reject(new Error("Ticket ID is required"));
  }
  return supportRequest("post", `/portal/support-tickets/${encodeURIComponent(ticketId)}/messages`, payload);
};

export const closeSupportTicket = (ticketId, payload = {}) => {
  if (!ticketId) {
    return Promise.reject(new Error("Ticket ID is required"));
  }
  return supportRequest("post", `/portal/support-tickets/${encodeURIComponent(ticketId)}/close`, payload);
};

export const reopenSupportTicket = (ticketId, payload = {}) => {
  if (!ticketId) {
    return Promise.reject(new Error("Ticket ID is required"));
  }
  return supportRequest("post", `/portal/support-tickets/${encodeURIComponent(ticketId)}/reopen`, payload);
};
